import React, { useEffect, useState } from 'react';
import './Restaurant.css';
import {
  Button,
  Row,
  Col,
  Typography,
  Spin,
  message,
  Card,
  Input
} from 'antd';
import {
    updateRestaurantStripeKey,
  getRestaurantDetails,
} from '../../Actions/RestaurantAction';
import { useDispatch, useSelector } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import _ from 'lodash';

const StripeKey = (props) => {
  const {
    editId,
    setEditId,
    setIsDefaultImageVisible,
    setShowUploadImage,
    setTabkey
  } = props;
  const dispatch = useDispatch();
  const [newFiles, setNewFiles] = useState();
  const IsEmpty = _.isEmpty(newFiles) ? true : false;
  const [preloadedRestaurantValue, setPreloadedRestaurantValue] = useState('');
  const {
    restaurantdeatils,
    allRestaurant,
    isCreateRestaurantLoading,
    isUpdateRestaurantLoading,
  } = useSelector((state) => {
    const {
      restaurantdeatils,
      allRestaurant,
      isCreateRestaurantLoading,
      isUpdateRestaurantLoading,
    } = state.restaurant;
    return {
        restaurantdeatils,
      allRestaurant,
      isCreateRestaurantLoading,
      isUpdateRestaurantLoading,
    };
  });
 
  const {
    handleSubmit,
    control,
    reset,
    clearErrors,
  } = useForm({
    defaultValues: {
        stripe_publishable_key: restaurantdeatils?.stripe_publishable_key,
        stripe_secret_key: restaurantdeatils?.stripe_secret_key,
    },
  });
  const handleCancel = () => {
    reset(preloadedRestaurantValue);
    setEditId('');
    setNewFiles([]);
    setShowUploadImage(false);
    setIsDefaultImageVisible(true);
    clearErrors();
  };
  useEffect(() => {
    if (editId) {
      dispatch(getRestaurantDetails());
    }
  },[dispatch]);
  
  const handleEditRestaurantMethod = (data) => {
    data.id = restaurantdeatils?.id;
    dispatch(
        updateRestaurantStripeKey(data, UpdateCallBack, faliureUpdate, IsEmpty)
    );
  };

  const UpdateCallBack = () => {
    setTabkey('1');
    setTimeout(() => {
      message.success('Your Restaurant Updated Successfully');
    }, 1000);
  };
  const faliureUpdate = (failureResponse) => {
    setTimeout(() => {
      message.error(failureResponse);
    }, 1000);
  };
  const inputStyles = {
    WebkitBoxShadow: '0 0 0 30px #f6f6f6 inset',
  };
  const isLoading = isCreateRestaurantLoading || isUpdateRestaurantLoading;
  return (
    <Spin spinning={isLoading}>
      <Card
        style={{
          backgroundColor: '#f6f6f6',
          border: 'rgb(229, 229, 229,1)',
        }}
      >
        <form
           onSubmit={handleSubmit(handleEditRestaurantMethod)}
        >
          <Spin spinning={isUpdateRestaurantLoading}>
            <>
            <Row gutter={[16, 16]} className='button'>
            <Col xl={16} lg={16} md={16} sm={24} xs={24} className='formRows'>
              <Typography className='formHeading'>
              Stripe Publishable Key &nbsp;
              </Typography>
              <Controller
                as={<Input style={inputStyles}></Input>}
                name='stripe_publishable_key'
                control={control}
                className='inputLabel'
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className='button'>
            <Col xl={16} lg={16} md={16} sm={24} xs={24} className='formRows'>
              <Typography className='formHeading'>
              Stripe Secret Key &nbsp;
              </Typography>
              <Controller
                as={<Input style={inputStyles}></Input>}
                name='stripe_secret_key'
                control={control}
                className='inputLabel'
              />
            </Col>
          </Row>
          <Row gutter={[22, 22]} className='button' justify='center'>
                <Col span={24}></Col>
                <Col xl={4} lg={4} md={4} sm={12} xs={12}>
                    <Button
                      className='cancelButton'
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                </Col>
                <Col xl={4} lg={4} md={4} sm={12} xs={12}>
                  <Button className='editDesignationButton' htmlType='submit'>
                    Update
                  </Button>
                </Col>
                <Col xl={8} lg={8} md={8} sm={12} xs={12}></Col>
              </Row>
            </>
          </Spin>
        </form>
      </Card>
    </Spin>
  );
};

export default StripeKey;

